import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id CA74F33C-3AEE-4EA9-93B4-643099DFD92D
 * name checkbox-multiple-blank-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-multiple-blank-outline.svg
 * tags
 * - Form 
 */
export const CheckboxMultipleBlankOutlineIcon = createSvgIcon(<><path d="M20,16V4H8V16H20M22,16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20A2,2 0 0,1 22,4V16M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16Z" /></>, 'CheckboxMultipleBlankOutlineIcon');
export default CheckboxMultipleBlankOutlineIcon